import { useMemo } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { useStorage } from '@/js/libs/hooks/useStorage/index.ts';
import { StorageKey } from '../types.js';
export const useImpersonatedUserStorage = () => {
    const { loadJSON, removeItem, saveString } = useStorage({ storage: window.localStorage });
    const forgetImpersonatedUser = useCallbackRef(() => {
        removeItem(StorageKey.IMPERSONATED_USER);
    });
    // Drops a stored user that no longer parses, so the next start begins without an impersonation.
    const getImpersonatedUser = useCallbackRef(() => loadJSON(StorageKey.IMPERSONATED_USER, () => removeItem(StorageKey.IMPERSONATED_USER)));
    // Stores only the identifiers of the user, whatever else the given object carries.
    const storeImpersonatedUser = useCallbackRef(({ email, firstName, lastName }) => {
        saveString(StorageKey.IMPERSONATED_USER, JSON.stringify({ email, firstName, lastName }));
    });
    return useMemo(() => ({
        forgetImpersonatedUser,
        getImpersonatedUser,
        storeImpersonatedUser,
    }), [forgetImpersonatedUser, getImpersonatedUser, storeImpersonatedUser]);
};
